(() => {
  if (window.productReviewTilesInitialized) return;
  window.productReviewTilesInitialized = true;

  const excerpt = (text) => {
    const words = text.trim().split(/\s+/);
    return words.length > 10 ? `${words.slice(0, 10).join(' ')}…` : text.trim();
  };

  const compact = () => {
    document.querySelectorAll('#judgeme_product_reviews .jm-review-item').forEach((review) => {
      if (review.dataset.reviewTile === 'true') return;
      const body = review.querySelector('.jdgm-review-content__body-content');
      if (!body?.textContent.trim()) return;
      const full = body.textContent.trim();
      const short = excerpt(full);
      review.dataset.reviewTile = 'true';
      body.textContent = short;
      if (short === full) return;
      review.classList.add('is-collapsed');
      review.tabIndex = 0;
      review.setAttribute('role', 'button');
      review.setAttribute('aria-expanded', 'false');
      review.setAttribute('aria-label', 'Read full customer review');
      const toggle = () => {
        const expanded = review.getAttribute('aria-expanded') === 'true';
        review.setAttribute('aria-expanded', String(!expanded));
        review.classList.toggle('is-collapsed', expanded);
        body.textContent = expanded ? short : full;
      };
      review.addEventListener('click', toggle);
      review.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
    });
  };

  compact();
  const observer = new MutationObserver(compact);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 30000);
})();
